import React, { useCallback } from 'react';
import { Podcast } from 'api';
import AIOptOut from 'components/AIOptOut';
import notifyError from 'components/notification';
import { EddyPref } from 'state/userPref/types';
import { useUpdateProjectSettings } from './state';
import useSetProjectRelatedPodcast from './state/useSetProjectRelatedPodcast';

export interface TranscriptAIOptOutProps {}

const TranscriptAIOptOut: React.FC<TranscriptAIOptOutProps> = () => {
  const { mutateAsync: updateProjectSettings } = useUpdateProjectSettings({
    awaitInvalidation: true,
  });

  const { mutateAsync: setProjectRelatedPodcast } =
    useSetProjectRelatedPodcast();

  const handleSubmit = useCallback(
    async (prefs?: EddyPref, podcast?: Podcast) => {
      if (!prefs) {
        return;
      }

      try {
        await setProjectRelatedPodcast({
          podcastId:
            podcast && prefs.isPodcastPersonalizationEnabled
              ? podcast.podcastId
              : undefined,
        });
        await updateProjectSettings({
          isAutoChaptersEnabled: prefs.isAutoChaptersEnabled,
          // when creating the project name suggestion applied is set to false when
          // the pref is set to true. In this way only projects that are created with this
          // set to true will later have their title replaced with a suggestion.
          isNameSuggestionApplied: !prefs.isAutoProjectNameEnabled,
        });
      } catch {
        notifyError({ heading: 'Error saving AI options. Please try again.' });
      }
    },
    [setProjectRelatedPodcast, updateProjectSettings],
  );

  return <AIOptOut onSubmit={handleSubmit} />;
};

export default TranscriptAIOptOut;
